module.exports = __webpack_public_path__ + "img/cadon.d966aa5d.png";